export default function () {
    return {
        restrict: 'E',
        replace: true,
        template: require('../partials-html/letter-composing-modal.html')
    };
}



// WEBPACK FOOTER //
// ./Client/app/sink/main/partials-js/letterComposingModal.js